var exports = {
  "a": "Box__2x0deM",
  "E": "Text__0PMadE",
};

module.exports = exports;
